import { render, staticRenderFns } from "./artEdit.vue?vue&type=template&id=0d999d58&scoped=true"
import script from "./artEdit.vue?vue&type=script&lang=js"
export * from "./artEdit.vue?vue&type=script&lang=js"
import style0 from "./artEdit.vue?vue&type=style&index=0&id=0d999d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d999d58",
  null
  
)

export default component.exports